import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import PropTypes from "prop-types";

import { fetchState } from "../../features/state/stateActions";
import { ApplicationState } from "../../redux/initialState";
import { State } from "../../features/state/stateTypes";

import { Dropdown, DropdownOption } from "@tal-gel/components-v2";
import { SelectedLocation } from "../../features/locationFilter/selectLocationTypes";
import { updateLocationFilter } from "../../features/locationFilter/selectLocationActions";

interface PropsFromState {
  loading: boolean;
  data: State[];
  errors?: string;
}

interface propsFromDispatch {
  fetchState: () => any;
  updateLocationFilter: (SelectedLocation: any) => any;
}

type AllProps = PropsFromState & propsFromDispatch;

const LocationSelect: React.FC<AllProps> = ({ data, fetchState, updateLocationFilter }) => {
  //needed to remember values when open / close mobile modal
  const value = useSelector<ApplicationState, string>(state => state.selectedLocation.data as string);

  useEffect(() => {
    if (!data.length) {
      fetchState();
    }
  }, [data.length, fetchState]);

  const UpdateFilter = (selected?: DropdownOption) => {
    if (!selected) return;
    const selectedLocation: SelectedLocation = {
      id: String(selected.value),
    };
    updateLocationFilter(selectedLocation);
  };

  const options = [{ value: "", label: "Select" }, ...data.map(item => ({ value: item.id, label: item.externalName }))];

  return (
    <Dropdown
      errorMessage=""
      id="locationDropdownId"
      label="Location"
      onSelect={UpdateFilter}
      options={options}
      value={options.find(option => option.value === value) || options[0]}
      placeholder="Select"
    />
  );
};

const mapStateToProps = ({ state }: ApplicationState) => ({
  loading: state.loading,
  errors: state.errors,
  data: state.data,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    fetchState: () => {
      dispatch(fetchState());
    },
    updateLocationFilter: (selectedLocation: SelectedLocation) => {
      dispatch(updateLocationFilter(selectedLocation));
    },
  };
};

LocationSelect.propTypes = {
  loading: PropTypes.any,
  data: PropTypes.any.isRequired,
  errors: PropTypes.string,
  fetchState: PropTypes.func.isRequired,
  updateLocationFilter: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationSelect);
